var t = function t(_t, n) {
    var i;
    i = "primary" === _t || "secondary" === _t ? "3X" : "textLinkCaret" === _t ? "6X" : "textLink" === _t ? "4X" : 0;
    return {
      rightSpacing: i,
      bottomSpacing: "3X"
    };
  },
  n = function n(t, _n) {
    var i = "small" === _n ? "5X" : "3X";
    return "textLink" === t && (i = "5X"), {
      topSpacing: "small" === _n ? "3X" : "1X",
      rightSpacing: "4X",
      bottomSpacing: i
    };
  },
  i = function i(t) {
    return {
      topSpacing: "3X",
      rightSpacing: "6X",
      bottomSpacing: "textLink" === t ? "5X" : "3X"
    };
  };
export { t as spacingForButton, n as spacingForTextLink, i as spacingForTextLinkCaret };